import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, message, Space } from 'antd';
import { UserOutlined, LockOutlined, AppstoreOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext.tsx';
import { useNavigate } from 'react-router-dom';
import { appAPI } from '../../services/api.ts';

const { Title, Text } = Typography;

const LoginForm: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [appVersion, setAppVersion] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppInfo = async () => {
      try {
        const appInfo = await appAPI.getAppInfo();
        setAppVersion(appInfo.app_version);
      } catch (error) {
        console.error('Errore nel caricamento delle informazioni app:', error);
        // Non mostrare errore all'utente per questo, è informativo
      }
    };

    fetchAppInfo();
  }, []);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.username, values.password);
      message.success('Login effettuato con successo');
      navigate('/dashboard');
    } catch (error: any) {
      if (error?.response?.status === 429) {
        message.error(error.response.data?.detail || 'Troppi tentativi di accesso. Riprova più tardi.');
      } else {
        message.error('Credenziali non valide');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
    }}>
      <Card style={{
        width: '100%',
        maxWidth: 400,
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        borderRadius: '12px',
      }}>
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          <div>
            <AppstoreOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '16px' }} />
            <Title level={2} style={{ margin: 0, color: '#001529' }}>
              NAVI
            </Title>
            <Text type="secondary">Sistema di Gestione Magazzino</Text>
            {appVersion && (
              <div style={{ marginTop: '8px' }}>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  Ver. {appVersion}
                </Text>
              </div>
            )}
          </div>

          <Form
            name="login"
            onFinish={onFinish}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: 'Inserisci il nome utente!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Nome utente"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Inserisci la password!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{ width: '100%', height: '44px' }}
              >
                Accedi
              </Button>
            </Form.Item>
          </Form>

          <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '16px' }}>
            <Text type="secondary">
              Utilizza le credenziali fornite dall'amministratore
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default LoginForm;
